import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import './styles/main.css';

// Strip tracking/external query params before Vue Router initializes so it
// never sees them and doesn't trigger a secondary navigation (which would
// fire scrollBehavior and potentially reset scroll position).
const _url = new URL(window.location.href);
if (_url.pathname === '/' && _url.search) {
  window.history.replaceState(null, '', _url.pathname);
}

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount('#app');
